import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IInvoiceListRequestModel } from '@app/interfaces/lsb/ap-invoice-models';
import { isNil } from '@app/utils';

@Injectable()
export class InvoiceService {
	endpointBase = '/api/invoice';

	constructor(private readonly http: HttpClient) {}

	public getInvoice(id: number): Observable<any> {
		return this.http.get(`${this.endpointBase}`, { params: { id } });
	}

	public getCreatedByUserList(): Observable<any> {
		return this.http.get(`${this.endpointBase}/get-created-by-user-list`);
	}

	public getInvoiceList(request: IInvoiceListRequestModel): Observable<any> {
		return this.http.get(`${this.endpointBase}/list`, {
			params: {
				FiscalYear: request.FiscalYear?.toString(),
				FromDate: request.FromDate?.toISOString(),
				ToDate: request.ToDate?.toISOString(),
				InvoiceStatusIds: isNil(request.InvoiceStatusIds) ? [] : request.InvoiceStatusIds.map((id) => id.toString()),
				MethodOfPaymentIds: isNil(request.MethodOfPaymentIds) ? [] : request.MethodOfPaymentIds.map((id) => id.toString()),
				InvoiceNumberSearch: request.InvoiceNumberSearch ?? '',
			},
		});
	}
}
